import Extension from 'owa-service/lib/contract/Extension';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { getExtensionPoint, updateMailComposeSurfaceNewAddin } from 'owa-addins-store';
import { logAppPinningTelemetry } from 'owa-addins-analytics';
import { lazyUpdateAddInArray } from 'owa-outlook-service-options';

export function pinMailComposeSurfaceAddins(
    addins: Extension[],
    newAdminInstalledAddins: string[],
    surfaceAddinKeys: string[]
): boolean {
    if (surfaceAddinKeys.length >= 3) {
        // User already has 3 or more addins pinned. We cannot pin more.
        return false;
    }

    // Filter MailCompose surface addins from newAdminInstalledAddins.
    let newAddinKeys: string[] = [];
    for (const addinKey of newAdminInstalledAddins) {
        for (const addin of addins) {
            if (addinKey != addin.Id.toLowerCase()) {
                continue;
            }

            if (!addin.ExtensionPointCollection) {
                continue;
            }

            let extensionPoint = getExtensionPoint(
                addin.ExtensionPointCollection,
                ExtensibilityModeEnum.MessageCompose
            );
            if (!extensionPoint) {
                continue;
            }

            newAddinKeys.push(addinKey);
        }
    }

    if (newAddinKeys.length <= 0) {
        // No new Mail ComposeSurface addin to pin.
        return false;
    }

    // Add admin addin keys in 'surfaceAddinKeys' until count reaches 3.
    // Also, find out first addin which we added in surfaceAddinKeys.
    let latestAddinKey: string;
    for (const addinKey of newAddinKeys) {
        if (surfaceAddinKeys.length >= 3) {
            break;
        }
        if (!latestAddinKey) {
            latestAddinKey = addinKey;
        }

        lazyUpdateAddInArray.importAndExecute(
            surfaceAddinKeys,
            addinKey,
            true /* isPushOperation */
        );

        // Log 'AppPining' telemetry event for addin pinned.
        logAppPinningTelemetry(addinKey, true /* isPinned */, ExtensibilityModeEnum.MessageCompose);
    }

    // Save latest admin addin installed addinId (key) in ExtensibilityState.
    updateMailComposeSurfaceNewAddin(latestAddinKey);

    return true;
}
